/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { NgIf } from "@angular/common";
import { Component, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";
import { Subject } from "rxjs";

@Component({
  selector: "empty-layout",
  templateUrl: "./empty.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FuseLoadingBarComponent, NgIf, RouterOutlet],
})
export class EmptyLayoutComponent implements OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
